import { defineMessages } from 'react-intl';

export const ReadingStepContent = defineMessages({
  installationStatus: {
    id: 'app.common.installationStatus',
    defaultMessage: 'Stav osazení',
  },
  installationStatusRequired: {
    id: 'app.common.installationStatusRequired',
    defaultMessage: 'Stav osazení je povinný',
  },
  installationStatusTooltip: {
    id: 'app.common.installationStatusTooltip',
    defaultMessage:
      'V jakém stavu je osazení měřidla.Pokud je měřidlo dálkově odečítáno, budeš muset upřesnit, kam tečou data',
  },
  meterMountTechnology: {
    id: 'app.common.meterMountTechnology',
    defaultMessage: 'Technologie osazení',
  },
  meterMountTechnologyTooltip: {
    id: 'app.common.meterMountTechnologyTooltip',
    defaultMessage: 'Jaká technologie osazení měřidla',
  },
  selectValid: {
    id: 'app.common.selectValid',
    defaultMessage: 'Vyber platné',
  },
  remoteReadingOwner: {
    id: 'app.common.remoteReadingOwner',
    defaultMessage: 'Kdo odečítá',
  },
  remoteReadingOwnerRequired: {
    id: 'app.common.remoteReadingOwnerRequired',
    defaultMessage: 'Musíš zadat vlastníka odečtu!',
  },
  remoteReadingOwnerPlaceholder: {
    id: 'app.common.remoteReadingOwnerPlaceholder',
    defaultMessage: 'Měřidlo odečítá BMS',
  },
  remoteReadingSerial: {
    id: 'app.common.remoteReadingSerial',
    defaultMessage: 'ID modulu',
  },
  remoteReadingSerialTooltip: {
    id: 'app.common.remoteReadingSerialTooltip',
    defaultMessage: 'Sériové číslo uvedené na modulu pro dálkový odečet',
  },
  remoteReadingSerialPlaceholder: {
    id: 'app.common.remoteReadingSerialPlaceholder',
    defaultMessage: 'Sériové číslo modulu',
  },
  requiresManualAks: {
    id: 'app.common.requiresManualAks',
    defaultMessage: 'Vypnout Robot',
  },
  requiresManualAksTooltip: {
    id: 'app.common.requiresManualAksTooltip',
    defaultMessage: 'Měřidlo není vhodné pro automatické přiřazení AKS robotem',
  },
  photoMeterModule: {
    id: 'app.ReadingStepContent.photoMeterModule',
    defaultMessage: 'Fotky osazení',
  },
  photoMeterModuleHelp: {
    id: 'app.ReadingStepContent.photoMeterModuleHelp',
    defaultMessage:
      'Pokud je na měřidle již osazený dálkový odečet nebo impulzní modul, nafoť použité příslušenství a detail, kam je napojeno',
  },
  photoMeterModuleRequired: {
    id: 'app.ReadingStepContent.photoMeterModuleRequired',
    defaultMessage: 'Musíš nahrát alespoň jednu fotku osazení!',
  },
  register: {
    id: 'app.RegisterStates.register',
    defaultMessage: 'Register {register}',
  },
  obisAndTariff: {
    id: 'app.common.obisAndTariff',
  },
  registerName: {
    id: 'app.common.registerName',
    defaultMessage: 'Nazev registru {register}',
  },
  registerStatus: {
    id: 'app.common.registerStatus',
    defaultMessage: 'Stav registru',
  },
  registerRequired: {
    id: 'app.common.registerRequired',
    defaultMessage: 'Zadejte stav registru',
  },
  registerPhotos: {
    id: 'app.common.registerPhotos',
    defaultMessage: 'Fotky odečtu registru',
  },
  registerPhotosRequired: {
    id: 'app.common.registerPhotosRequired',
    defaultMessage: 'Vyfoť prosím stav registru',
  },
  newRegister: {
    id: 'app.common.newRegister',
    defaultMessage: 'Nový registr',
  },
  removeRegister: {
    id: 'app.common.removeRegister',
    defaultMessage: 'Odebrat registr',
  },
  readingGroup: {
    id: 'app.ReadingStepContent.readingGroup',
    defaultMessage: 'Odečtová skupina',
  },
  readingGroupPlaceholder: {
    id: 'app.ReadingStepContent.readingGroupPlaceholder',
    defaultMessage: 'Vyber odečtovou skupinu',
  },
  createReadingGroup: {
    id: 'app.ReadingStepContent.createReadingGroup',
    defaultMessage: 'Vytvořit odečtovou skupinu "{groupName}"',
  },
  inbuiltOutputs: {
    id: 'app.common.inbuiltOutputs',
  },
  meterAddon: {
    id: 'app.common.meterAddon',
  },
  registers: {
    id: 'app.common.registers',
  },
  technology: {
    id: 'app.inventoryMeterOutput.technology',
  },
  isOccupied: {
    id: 'app.inventoryMeterOutput.isOccupied',
  },
});

export const ReadingStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
});
